import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import 'element-ui/lib/theme-chalk/index.css';//element样式
import "@/assets/index.scss"
import { Loading } from "element-ui"

// 公共库
import "cloudcc-ccdk/lib/ccdk.min.js";

Vue.use(Loading.directive)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
